import { ReceiptRejection } from '@components'

import { Space } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'

import { EInvoiceLifecycleActions } from '@features/eInvoicing/elements/EInvoiceLifecycleActions'
import { useFREInvoiceStatusInfo } from '@features/eInvoicing/hooks/useFREInvoiceStatusInfo'
import { EInvoiceLifecycleTrackingSources } from '@views/receipts/enums/tracking'

import { useAttachmentPreviewModal } from '../../../../context/attachmentPreviewModalContext'
import { EInvoiceApproveButton } from './elements/EInvoiceApproveButton'
import { ManageUploadButton } from './elements/ManageUploadButton'
import * as Styled from './styles'

export const AttachmentDetailsFooter = (): ReactElement => {
  const {
    attachmentId,
    close,
    eInvoiceStatus,
    footerButton,
    handleEInvoiceRejection,
    isBlocked,
    isEDocument,
    isEInvoicingOnly,
    isFrenchEInvoice,
    isShoeboxReadOnly,
  } = useAttachmentPreviewModal()
  const [isApproveProcessing, setIsApproveProcessing] = useState(false)
  const [isLifecycleProcessing, setIsLifecycleProcessing] = useState(false)

  const handleApproveProcessingChange = useCallback((isProcessing: boolean) => {
    setIsApproveProcessing(isProcessing)
  }, [])

  const handleLifecycleProcessingChange = useCallback((isProcessing: boolean) => {
    setIsLifecycleProcessing(isProcessing)
  }, [])

  const { isFinal: isFinalStatus } = useFREInvoiceStatusInfo(eInvoiceStatus) || { isFinal: false }

  const canActOnEInvoice = isShoeboxReadOnly || isEInvoicingOnly
  const showApproveCta = canActOnEInvoice && isEDocument && isFrenchEInvoice && !isFinalStatus
  const showLifecycleActions = isEDocument && !isFinalStatus && (canActOnEInvoice || !isBlocked)

  return (
    <Styled.FooterWrapper>
      {footerButton || (!canActOnEInvoice && <ManageUploadButton isEDocument={isEDocument} blocked={isBlocked} />)}
      {showApproveCta && (
        <>
          <Space size="s8" />
          <EInvoiceApproveButton
            attachmentId={attachmentId}
            disabled={isLifecycleProcessing}
            fullWidth
            onProcessingChange={handleApproveProcessingChange}
            onSuccess={close}
            previousStatus={eInvoiceStatus}
            trackingSource={EInvoiceLifecycleTrackingSources.ReceiptPreview}
          />
        </>
      )}
      {showLifecycleActions && (
        <>
          <Space size="s8" />
          {isFrenchEInvoice ? (
            <EInvoiceLifecycleActions
              attachmentId={attachmentId}
              disabled={isApproveProcessing}
              fullWidth
              onProcessingChange={handleLifecycleProcessingChange}
              onSuccess={close}
              previousStatus={eInvoiceStatus}
              trackingSource={EInvoiceLifecycleTrackingSources.ReceiptPreview}
            />
          ) : (
            <ReceiptRejection
              attachmentId={attachmentId}
              onSuccess={handleEInvoiceRejection}
              size="md"
              trackingSource={EInvoiceLifecycleTrackingSources.ReceiptPreview}
            />
          )}
        </>
      )}
    </Styled.FooterWrapper>
  )
}
